import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'
import LogoImg from '../../../assets/login/logo.png'
import OrdenoLogo from '../../../assets/login/ordeno-logo.png'
import GoogleLogoImg from '../../../assets/login/googlelogo.png'
import ApiService from '../../../services/ApiService'
import UserContext from '../../../contexts/UserContext'
import { useGoogleLogin } from '@react-oauth/google'
import { GoogleLogin } from '@react-oauth/google'
import jwtDecode from 'jwt-decode'
import { validateToken } from '../../../utils/tokenValidation'

import {
  Card,
  Brand,
  Title,
  Subtitle,
  GoogleButtonWrapper,
  Divider,
  DividerLine,
  DividerText,
  FormGroup,
  Label,
  InputField,
  RememberRow,
  RememberLeft,
  Checkbox,
  ForgotPass,
  SubmitButton,
  BottomText,
  ErrorMsg,
  ErrContainer,
} from './style'

import { Logo } from '../style'
import CompleteRegister from '../CompleteRegister'

interface MainBoxProps {
  setPage: (page: string) => void
  setUserlogin: Dispatch<SetStateAction<LoginInfo>>
}

interface LoginInfo {
  email: string
  password: string
}

interface GoogleUser {
  aud: string
  azp: string
  email: string
  email_verified: boolean
  exp: number
  family_name: string
  given_name: string
  iat: number
  iss: string
  jti: string
  name: string
  nbf: number
  picture: string
  sub: string
}

const MainBox: React.FC<MainBoxProps> = (props) => {
  const {
    user,
    setUser,
    googleEmail,
    setGoogleEmail,
    googleName,
    setGoogleName,
    googlePicture,
    setGooglePicture,
    setToken,
  } = useContext(UserContext)
  const [userLogin, setUserLogin] = useState<string>('')
  const [userPassword, setUserPassword] = useState<string>('')
  const [nameButton, setNameButton] = useState<string>('Entrar')
  const [errLogin, setErrLogin] = useState<number>(0)
  const [rememberMe, setRememberMe] = useState<boolean>(false)

  useEffect(() => {
    if (user && (user.id || user.sub) && user.approved === 'approved') {
      window.location.href = '/panel'
    } else if (user && (user.id || user.sub) && user.approved !== 'approved') {
      window.location.href = '/accessvalidation'
    }
  }, [user])

  const changePage = (_Page: string) => {
    props.setPage(_Page)
  }

  const handleLogin = async () => {
    console.log('🔑 [LOGIN] Iniciando processo de login:', {
      hasEmail: !!userLogin,
      hasPassword: !!userPassword,
      email: userLogin,
      timestamp: new Date().toISOString(),
    })

    if (userLogin && userPassword) {
      setNameButton('Entrando')
      setErrLogin(0)

      console.log('🔑 [LOGIN] Chamando ApiService.auth.login...')

      try {
        const response = await ApiService.auth.login({
          email: userLogin,
          password: userPassword,
        })

        console.log('✅ [LOGIN] Resposta do backend recebida:', {
          hasAccessToken: !!response.data.access_token,
          tokenLength: response.data.access_token?.length,
          tokenPreview: response.data.access_token
            ? `${response.data.access_token.substring(0, 50)}...`
            : null,
          responseStatus: response.status,
          headers: response.headers,
        })

        if (response.data.access_token) {
          const token = response.data.access_token

          console.log('🔑 [LOGIN] Salvando token no localStorage...')
          localStorage.setItem('token', token)

          console.log('🔑 [LOGIN] Validando token...')
          const validation = validateToken(token)

          console.log('✅ [LOGIN] Resultado da validação do token:', {
            isValid: validation.isValid,
            isExpired: validation.isExpired,
            hasTenantId: !!validation.tenantId,
            tenantId: validation.tenantId,
            message: validation.message,
            decodedToken: validation.decodedToken,
          })

          if (validation.decodedToken) {
            console.log('🔑 [LOGIN] Atualizando contexto do usuário...')
            setToken(token)
          } else {
            console.error('❌ [LOGIN] Token decodificado não encontrado')
          }
        } else {
          console.error('❌ [LOGIN] Access token não encontrado na resposta')
        }
      } catch (err) {
        console.error('❌ [LOGIN] Erro durante login:', {
          error: err,
          message: err instanceof Error ? err.message : String(err),
          status: (err as any)?.response?.status,
          data: (err as any)?.response?.data,
          headers: (err as any)?.response?.headers,
        })
        setNameButton('Entrar')
        setErrLogin(400)
      }
    } else {
      console.warn('⚠️ [LOGIN] Email ou senha não fornecidos')
    }
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleLogin();
  };

  return !googleEmail ? (
    <Card>
      {/* LOGO ORDENO */}
      <Brand>
        <img src={OrdenoLogo} alt='ordeno' />
      </Brand>

      <Title>Olá!</Title>
      <Subtitle>Por favor, entre em sua conta para continuar.</Subtitle>

      {/* BOTÃO GOOGLE */}
      <GoogleButtonWrapper>
        <GoogleLogin
          onSuccess={async (credentialResponse: any) => {
            try {
              const res = await ApiService.auth.googleAuth(credentialResponse)

              if (res.data.result.status === 200) {
                const response = res.data.result
                const token = response.data.userToken.access_token

                localStorage.setItem('token', token)

                const validation = validateToken(token)
                if (validation.decodedToken) {
                  setToken(token)
                }
              } else {
                const response = res.data.result
                setGoogleEmail(response.data.email)
                setGoogleName(response.data.name)
                setGooglePicture(response.data.picture)

                if (googleEmail && googleName) {
                  window.location.href = '/completeRegister'
                }
              }
            } catch (err: any) {
              console.log(err)
            }
          }}
          onError={() => {
            console.log('Login Failed')
          }}
        />
      </GoogleButtonWrapper>

      {/* DIVISOR "ou" */}
      <Divider>
        <DividerLine />
        <DividerText>ou</DividerText>
        <DividerLine />
      </Divider>

      {/* EMAIL */}
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <FormGroup>
          <Label htmlFor='email'>Email</Label>
          <InputField
            id='email'
            type='text'
            placeholder='Digite aqui'
            value={userLogin}
            onChange={(e) => setUserLogin(e.target.value)}
          />
        </FormGroup>
        {/* SENHA */}
        <FormGroup>
          <Label htmlFor='password'>Senha</Label>
          <InputField
            id='password'
            type='password'
            placeholder='Digite aqui'
            value={userPassword}
            onChange={(e) => setUserPassword(e.target.value)}
          />
        </FormGroup>
        {/* ERRO */}
        {errLogin === 400 && <ErrorMsg>Email e/ou senha inválidos</ErrorMsg>}
        {/* LEMBRAR / ESQUECI */}
        <RememberRow>
          <RememberLeft>
            <Checkbox
              type='checkbox'
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <span>Lembrar de mim</span>
          </RememberLeft>
          <ForgotPass type='button' onClick={() => props.setPage('PassReset')}>
            Esqueci minha senha
          </ForgotPass>
        </RememberRow>
        <SubmitButton type='submit' onClick={handleLogin}>{nameButton}</SubmitButton>
      </form>

      <BottomText>
        Ainda não tem conta?
        <button
          className='registerBtn'
          onClick={() => props.setPage('Register')}
        >
          Cadastre-se
        </button>
      </BottomText>
    </Card>
  ) : (
    <CompleteRegister />
  )
}

export default MainBox
